export default __webpack_public_path__ + "static/media/warningIcon.3349cc28.svg";